import { render } from "./Home_component.vue?vue&type=template&id=921d1cbc&scoped=true"
import script from "./Home_component.vue?vue&type=script&lang=js"
export * from "./Home_component.vue?vue&type=script&lang=js"

import "./Home_component.vue?vue&type=style&index=0&id=921d1cbc&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-921d1cbc"]])

export default __exports__